<!-- Kabuk canlandırma (02.10.2026): eski hâli
<dx-drop-down-button
    *ngIf="renderDropdown"
    displayExpr="name"
    stylingMode="text"
    [dropDownOptions]="{  
      width: '10vw'  
    }" 
    [text]="userName"
    [icon]="profileService.getCurrentItemIcon()"
    [items]="profileSettings"
    (onItemClick)="onItemClick($event)"
  >
  </dx-drop-down-button>
  <dx-drop-down-button
    *ngIf="!renderDropdown"
    displayExpr="name"
    stylingMode="text"
    [dropDownOptions]="{  
      width: '10vw'  
    }" 
    [text]="userName"
    [icon]="profileService.getCurrentItemIcon()"
    [items]="profileSettings"
    (onItemClick)="onItemClick($event)"
  >
  </dx-drop-down-button>
-->
<!-- Kullanıcı adı yanında baş harfli avatar (tema vurgusunda). DevExtreme 'template' ana düğmede uygulanmadığı için
     avatar icon sınıfı (.profil-avatar) + CSS --harf değişkeniyle çizilir. -->
<span class="profil-kap" [style.--harf]="harfCss">
<dx-drop-down-button
    *ngIf="renderDropdown"
    displayExpr="name"
    stylingMode="text"
    [dropDownOptions]="{  
      width: '10vw'  
    }" 
    [text]="userName"
    icon="profil-avatar"
    [items]="profileSettings"
    (onItemClick)="onItemClick($event)"
  >
  </dx-drop-down-button>
  <dx-drop-down-button
    *ngIf="!renderDropdown"
    displayExpr="name"
    stylingMode="text"
    [dropDownOptions]="{  
      width: '10vw'  
    }" 
    [text]="userName"
    icon="profil-avatar"
    [items]="profileSettings"
    (onItemClick)="onItemClick($event)"
  >
  </dx-drop-down-button>
</span>
